import { render, staticRenderFns } from "./ProviderCard.vue?vue&type=template&id=9cf831f2&"
import script from "./ProviderCard.vue?vue&type=script&lang=js&"
export * from "./ProviderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports